export const ModelList = [
  
    {
        'group':'Drone',
        'name':'Pit3dMeshes',
        'models':
        [
            // {name:'eu_pit',url:'./models/pit/eu_pit-transformed.glb'},
            {name:'EOM_Dec24',url:'./models/optimised/Pit010125_S_O_D.glb'},
            {name:'EOM_Mar25',url:'./models/optimised/Pit160425_S_O_D.glb'},
            {name:'EOM_Jul25',url:'./models/optimised/Pit01072025_S_O_D.glb'},
            {name:'EOM_Sep25',url:'./models/optimised/Pit01092025_S_O_D.glb'},
        ]   

    },
    {
        'group':'Drone',
        'name':'PitSolids',
        'models':
        [
            {name:'EOM_Dec24T',url:'./models/optimised/Pit010125_T_O_D.glb'},
            {name:'EOM_Mar25T',url:'./models/optimised/Pit160425_T_O_D.glb'},
            {name:'EOM_Jul25T',url:'./models/optimised/Pit01072025_T_O_D.glb'},
            {name:'EOM_Sep25T',url:'./models/optimised/Pit01092025_T_O_D.glb'},
        ]   

    },
    {
        'group':'Holes',
        'name':'Holes',
        'models':
        [
            {type:'holes',name:'Historic_DD',url:'./files/Holes210624.zip' , dataset:'EU_RES_HIST', holetype:'DD'},
            {type:'holes',name:'Historic_RC',url:'./files/Holes210624.zip', dataset:'EU_RES_HIST', holetype:'RC'},
            {type:'holes',name:'DGZ_RC',url:'./files/Holes210624.zip', dataset:'EU_GC_Surface', holetype:'RC'},
            {type:'holes',name:'EUG Plan DD',url:'./files/Holes210624.zip', dataset:'EUG_PlanDD', holetype:'DD_PLAN'},
            {type:'holes',name:'EUPit Plan DD1',url:'./files/Holes210624.zip', dataset:'EUPit_PlanDD_1', holetype:'DD_PLAN'},
            {type:'holes',name:'EUPit Plan DD2',url:'./files/Holes210624.zip', dataset:'EUPit_PlanDD_2', holetype:'DD_PLAN'},
            {type:'cachedholes',name:'BH_EU_GC_Surface',hole_url:'./files/holes/DH_Collar.csv',assay_url:'./files/holes/DH_Assays.csv',survey_url:'./files/holes/DH_Survey.csv',dataset:'EU_GC_Surface',holetype:'BH',year:[],programType:[]},
            {type:'cachedholes',name:'RC_EU_GC_Surface',hole_url:'./files/holes/DH_Collar.csv',assay_url:'./files/holes/DH_Assays.csv',survey_url:'./files/holes/DH_Survey.csv',dataset:'EU_GC_Surface',holetype:'RC',year:[],programType:[]},
            {type:'cachedholes',name:'DD_EU_GC_Surface',hole_url:'./files/holes/DH_Collar.csv',assay_url:'./files/holes/DH_Assays.csv',survey_url:'./files/holes/DH_Survey.csv',dataset:'EU_GC_Surface',holetype:'DD',year:[],programType:[]},
            {type:'cachedholes',name:'DD_EU_GEOTECH',hole_url:'./files/holes/DH_Collar.csv',assay_url:'./files/holes/DH_Assays.csv',survey_url:'./files/holes/DH_Survey.csv',dataset:'EU_GEOTECH',holetype:'DD',year:[],programType:[]},
            {type:'cachedholes',name:'DD_EU_RES_SURF',hole_url:'./files/holes/DH_Collar.csv',assay_url:'./files/holes/DH_Assays.csv',survey_url:'./files/holes/DH_Survey.csv',dataset:'EU_RES_SURF',holetype:'DD',year:[],programType:[]},
            {type:'cachedholes',name:'DD_EU_RES_UG',hole_url:'./files/holes/DH_Collar.csv',assay_url:'./files/holes/DH_Assays.csv',survey_url:'./files/holes/DH_Survey.csv',dataset:'EU_RES_UG',holetype:'DD',year:[],programType:['DD']},
            {type:'cachedholes',name:'DD_PLAN',hole_url:'./files/holes/DH_Collar.csv',assay_url:'./files/holes/DH_Assays.csv',survey_url:'./files/holes/DH_Survey.csv',dataset:'EU_RES_UG',holetype:'DD',year:['2025'],programType:['RES_PLAN']},
            {type:'cachedholes',name:'DD_PLAN_2A',hole_url:'./files/holes/DH_Collar.csv',assay_url:'./files/holes/DH_Assays.csv',survey_url:'./files/holes/DH_Survey.csv',dataset:'EU_RES_UG',holetype:'DD',year:['2025'],programType:['RES_PLAN_2A']},
            {type:'cachedholes',name:'DD_PLAN_2B',hole_url:'./files/holes/DH_Collar.csv',assay_url:'./files/holes/DH_Assays.csv',survey_url:'./files/holes/DH_Survey.csv',dataset:'EU_RES_UG',holetype:'DD',year:['2025'],programType:['RES_PLAN_2B']},
            {type:'cachedholes',name:'EXPLORATION',hole_url:'./files/holes/DH_Collar.csv',assay_url:'./files/holes/DH_Assays.csv',survey_url:'./files/holes/DH_Survey.csv',dataset:'EU_RES_UGP',holetype:'DD',year:['2025'],programType:['RES_PLAN_EXPO']},
            {type:'cachedholes',name:'INFILL',hole_url:'./files/holes/DH_Collar.csv',assay_url:'./files/holes/DH_Assays.csv',survey_url:'./files/holes/DH_Survey.csv',dataset:'EU_RES_SURFP',holetype:'DD',year:['2025'],programType:['RES_PLAN_IF']},
        
        ]   

    },
    {
        'group':'Drone',
        'name':'Dumps',
        'models':
        [
            {name:'SouthDump',url:'./models/dumps/south_dump/300623-transformed.glb'},
            {name:'SouthDump0925',url:'./models/optimised/SouthDump300925_S_O_D.glb'},
            {name:'NorthWestDump',url:'./models/dumps/north_west_dump/300623-transformed.glb'},
            {name:'NorthRiverDump1025',url:'./models/optimised/NRDump151025_S_O_D.glb'},
            {name:'NorthWestDump1025',url:'./models/optimised/NWDump151025_S_O_D.glb'}
        ]   

    },
    {
        'group':'Drone',
        'name':'Tailings',
        'models':
        [
            {name:'TSF',url:'./models/tsf/190123-transformed.glb'},
        ]   

    },
    {
        'group':'Drone',
        'name':'Stockpiles',
        'models':
        [
            {name:'Stockpile',url:'./models/stockpile/070723-transformed.glb'},
            {name:'Rompad1025',url:'./models/optimised/Rompad181025_S_O_D.glb'},
        ]   

    },
    {
        'group':'Plan',
        'name':'LOM',
        'models':
        [
            {name:'PB1',url:'./models/plan/PB1.glb'},
            {name:'PB2',url:'./models/plan/PB2.glb'},
            {name:'PB3',url:'./models/plan/PB3.glb'},
            {name:'PB5',url:'./models/plan/PB5.glb'},
            {name:'PitDesign',url:'./models/plan/EUREKA_PIT_DESIGN_.glb'},
            {name:'PitDesign2026',url:'./models/plan/EU_PIT_DESIGN_2026.glb'},
            {name:'UG DECLINE',url:'./models/plan/UG_DECLINE.glb'},
            {name:'UGDevelopmemt',url:'./models/plan/EUREKA_UG_PLANNED_DEVELOPMENT_-transformed.glb'},
            {name:'UGStopes',url:'./models/plan/EUREKA_UG_PLANNED_STOPES.glb'},
            ]   

    },
    {
        'group':'Geology',
        'name':'Orebodies',
        'models':
        [
            {name:'molly',url:'./models/orebodies/molly.glb'},
            {name:'molly2',url:'./models/orebodies/molly2.glb'},
            {name:'molly3',url:'./models/orebodies/molly3.glb'},
            {name:'molly4',url:'./models/orebodies/molly4.glb'},
            {name:'molly5',url:'./models/orebodies/molly5.glb'},
            {name:'satellite',url:'./models/orebodies/satellitebody.glb'},
            {name:'satellite2',url:'./models/orebodies/satellite2.glb'},
            {name:'satellite10',url:'./models/orebodies/satelliteten.glb'},
            {name:'streaky',url:'./models/orebodies/streaky.glb'},
            {name:'streaky2',url:'./models/orebodies/streaky2.glb'},
            {name:'zebra',url:'./models/orebodies/zebra.glb'},
            {name:'zebra1',url:'./models/orebodies/zebra1.glb'},
            {name:'zebra2',url:'./models/orebodies/zebra2.glb'},
        ]   

    },
    
    {
        'group':'Geology',
        'name':'Geology.BlockModels',
        'models':
        [   
            {type:'blockmodel',name:'BM',url:'./models/blockmodel/au_eureka_blockmodel.zip', dx:0,dy:0,dz:0,size:'1mb',grade:'AU'},
            {type:'blockmodel',name:'GCMODEL_2025',url:'./models/blockmodel/EU_GC_15122025.zip', dx:0,dy:0,dz:0,size:'1mb',grade:'AU'},
        ]   

    },
    {
        'group':'Survey',
        'name':'Blast',
        'models':
        [
            {name:'Jan2023',url:'./models/blasts/Jan2023.glb'},
            {name:'Feb2023',url:'./models/blasts/Feb2023.glb'},
            {name:'Mar2023',url:'./models/blasts/Mar2023.glb'},
            {name:'Apr2023',url:'./models/blasts/Apr2023.glb'},
            {name:'May2023',url:'./models/blasts/May2023.glb'},
            {name:'Jun2023',url:'./models/blasts/Jun2023.glb'},
            {name:'Sep2023',url:'./models/blasts/Sept2023.glb'},
            {name:'Apr2024',url:'./models/blasts/Apr2024.glb'},
            {name:'May2024',url:'./models/blasts/May2024.glb'},
            {name:'Jun2024',url:'./models/blasts/Jun2024.glb'},
            {name:'Jan2025',url:'./models/blasts/Jan2025.glb'},
            {name:'Feb2025',url:'./models/blasts/Feb2025.glb'},
            {name:'Mar2025',url:'./models/blasts/Mar2025.glb'},
            {name:'Apr2025',url:'./models/blasts/Apr2025.glb'},
            {name:'May2025',url:'./models/blasts/May2025.glb'},
            {name:'Jun2025',url:'./models/blasts/Jun2025.glb'},
            {name:'Jul2025',url:'./models/blasts/Jul2025.glb'},
            {name:'Aug2025',url:'./models/blasts/Aug2025.glb'},
            {name:'Sep2025',url:'./models/blasts/Sep2025.glb'},
            {name:'Blasts2025',url:'./models/optimised/2025BLASTS_T.glb'},
        ]   

    },
    {
        'group':'Survey',
        'name':'UGWorkings',
        'models':
        [
            {name:'Level1',url:'./models/underground/l1_dev.glb'},
            {name:'Level2',url:'./models/underground/l2_dev.glb'},
            {name:'Level3',url:'./models/underground/l3_dev.glb'},
            {name:'Level4',url:'./models/underground/l4_dev.glb'},
        ]   

    }
    

    
]